import React from "react";

const Loader2 = ()=>{
    return(
        <div className="center-body" style={{ height: '200px' }}><div className="loader-circle-2"></div></div>
    )
}

export default Loader2